"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withErrorRecovery = void 0;
const withErrorRecovery = function (callback, recoveryCallback) {
  return async function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    try {
      const response = await callback(...args);
      return response;
    } catch (error) {
      return recoveryCallback(error, ...args);
    }
  };
};
exports.withErrorRecovery = withErrorRecovery;